<template>
   <Btn
      :text="{ do: 'Assign', done: 'Assigned', undo: 'Unassign' }"
      class="green"
      action
      :actionActive="isAssigned"
      @handle-action="toggleAssignClassModal"
   >
      <IconAltCircleCheck v-if="!isAssigned" />
      <IconAltCircleCheckFilled v-else />
   </Btn>

   <AssignClassModal
      v-if="openAssignClassModal"
      :open="openAssignClassModal"
      :targetType="targetType"
      @close="toggleAssignClassModal"
   />
</template>

<script setup lang="ts">
import IconAltCircleCheck from "~/assets/images/icons/alt-circle-check.svg?component";
import IconAltCircleCheckFilled from "~/assets/images/icons/alt-circle-check-filled.svg?component";
const classesStore = useClassesStore();
const { activeClasses } = storeToRefs(classesStore);

const props = defineProps({
   // open: { type: Boolean, required: true },
   targetType: {
      type: String,
      required: true,
      validator(value) {
         return ["teachables", "media", "units"].includes(value);
      },
   },
   // targetSlug: { type: String, required: true },
   targetId: { type: Number, default: null },
});

const openAssignClassModal = ref(false);
const isAssigned = computed(() => {
   if (!activeClasses.value.length) {
      return [];
   }
   if (props.targetType == "units") {
      return activeClasses.value?.some((cls) =>
         cls.unit_sequences?.some((seq) => seq?.id === props.targetId),
      );
   } else if (props.targetType == "teachables") {
      return activeClasses.value?.some((cls) =>
         cls.modules?.some((mod) => mod?.id === props.targetId),
      );
   }
});

const toggleAssignClassModal = () => {
   openAssignClassModal.value = !openAssignClassModal.value;
};
</script>
